var React = require('react');

function EmailInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M14.0006 6.16663C12.3292 7.42245 10.2513 8.16663 7.99967 8.16663C5.74802 8.16663 3.67019 7.42245 1.9987 6.16663M3.83301 3.16663H12.1663C13.2709 3.16663 14.1663 4.06206 14.1663 5.16663V10.8333C14.1663 11.9379 13.2709 12.8333 12.1663 12.8333H3.83301C2.72844 12.8333 1.83301 11.9379 1.83301 10.8333V5.16663C1.83301 4.06206 2.72844 3.16663 3.83301 3.16663Z","stroke":"black","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round"}));
}

EmailInline.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = EmailInline;

EmailInline.default = EmailInline;
